import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ReadingGroup } from 'shared/models';

import { QueryResult } from './query-result';

@Injectable({
  providedIn: 'root',
})
export class BookReadingGroupsAPIService {
  constructor(private _http: HttpClient) {}

  get(
    bid: string,
    offset: number = 0,
    limit: number = 100,
    q: string = '',
    order_by:
      | 'recent'
      | 'member_count'
      | 'highlight_count'
      | 'memo_count' = 'recent',
    public_only: boolean = false,
    like_only: boolean = false
  ): Observable<
    QueryResult<ReadingGroup> & { highlight_count: number; memo_count: number }
  > {
    return this._http.get<
      QueryResult<ReadingGroup> & {
        highlight_count: number;
        memo_count: number;
      }
    >(`/api/v1/books/${bid}/groups`, {
      params: {
        offset,
        limit,
        q,
        order_by,
        public_only: public_only ? 1 : 0,
        like_only: like_only ? 1 : 0,
      },
      withCredentials: true,
    });
  }

  // 그룹 즐겨찾기
  addLike(groupId: number): Observable<void> {
    return this._http.put<void>(
      `/api/v1/groups/${groupId}/like`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // 그룹 즐겨찾기 해제
  removeLike(groupId: number): Observable<void> {
    return this._http.delete<void>(`/api/v1/groups/${groupId}/like`, {
      withCredentials: true,
    });
  }
}
